const API_PREFIX = '/shifts'

export const createShiftEndpoint = `${API_PREFIX}`
export const getShiftsEndpoint = `${API_PREFIX}`
export const deleteShiftEndpoint = (id: string) => `${API_PREFIX}/${id}`
export const updateShiftWorkingHoursEndpoint = (id: string) => `${API_PREFIX}/${id}/working-hours`
export const updateShiftPauseEndpoint = (id: string) => `${API_PREFIX}/${id}/pause`